// extracted by mini-css-extract-plugin
export var rateTable = "_49-0";